import { foundationFlyoutStyles } from '@genesislcap/foundation-ui';
import { neutralFillHover, neutralForegroundRest, neutralLayer2 } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const zeroFlyoutStyles = css `
  ${foundationFlyoutStyles}
  div.flyout {
    background-color: ${neutralLayer2};
    border-color: ${neutralFillHover};
    color: ${neutralForegroundRest};
  }

  :host([position='left']) div.flyout {
    border-right-style: solid;
    border-right-width: 1px;
  }

  :host([position='right']) div.flyout {
    border-left-style: solid;
    border-left-width: 1px;
  }

  div.exit {
    cursor: pointer;
    padding: 5px 8px;
  }

  div.exit:hover {
    background-color: ${neutralFillHover};
    border-radius: 3px;
  }
`;
